import React, { createRef } from 'react'
import { CreateUserPageProps } from './CreateUserPage.types'
import styles from './CreateUserPage.module.scss'
import cl from 'classnames'
import { GalleryDropZoneRef, PageHeader } from 'components/shared'
import { IconUserManagement } from 'assets'
import { UserInfoSection } from '../UserInfoSection'

const CreateUserPageComponent = (props: CreateUserPageProps) => {
  const {
    history: {
      push,
      goBack
    }
  } = props

  const imagesRef: GalleryDropZoneRef = createRef()

  const handleSave = () => {
    imagesRef.current.handleImages()
      .then(imagesRef.current.getImages)
      .then(images => console.log('images', images))
  }

  return (
    <div className={cl(styles.pageContainer)}>
      <PageHeader
        navSegments={[
          {
            label: 'User management',
            icon: IconUserManagement,
            onClick: () => push('/user-management'),
            iconProps: { viewBox: '0 0 22 22' }
          },
          {
            label: 'Create user'
          }
        ]}
        buttons={[
          {
            children: 'Discard',
            preset: 'secondary',
            onClick: goBack
          },
          {
            children: 'Save',
            preset: 'primary',
            onClick: handleSave,
            disabled: false
          }
        ]}
      />
      <UserInfoSection />
    </div>
  )
}

const CreateUserPage = CreateUserPageComponent
export { CreateUserPage }
